module.exports = __webpack_public_path__ + "media/application/media/images/three-dots-b98a8c76a048247a195c7eaf0dbb86f9.svg";